import { render } from "./DesignerProfile.vue?vue&type=template&id=95036d18&scoped=true"
import script from "./DesignerProfile.vue?vue&type=script&lang=js"
export * from "./DesignerProfile.vue?vue&type=script&lang=js"

import "./DesignerProfile.vue?vue&type=style&index=0&id=95036d18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95036d18"]])

export default __exports__